import React from 'react';

import { Provider } from 'react-redux';

import 'react-toastify/dist/ReactToastify.css';

import store from './store';

import { ConfigProvider, ThemeConfig } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import Router from './routers';

const App: React.FC = () => {
  const theme: ThemeConfig = {
    token: {
      colorPrimary: '#e72c45',
    },
    components: {
      Button: {
        colorPrimary: '#e8595d',
        colorPrimaryHover: '#e72c47',
        paddingInline: 30,
        controlHeight: 42,
      },
      Select: {
        // paddingContentVertical: 30,
        controlHeight: 42,
      },
      Input: {
        paddingBlock: 10,
      },
      Layout: {
        headerBg: '#fff',
        bodyBg: '#fff',
        headerPadding: 20,
      },
      Menu: {
        iconMarginInlineEnd: '20px',
        iconSize: 18,
        itemMarginInline: 10,
        itemHeight: 50,
      },
      DatePicker: {
        controlHeight: 42,
      },
    },
  };

  return (
    <>
      {/* <ConfigProvider locale={viVN}>
        <Provider store={store}>
          <AppRouter />
          <ConfirmModal />
          <ToastContainer position="bottom-center" autoClose={3000} />
        </Provider>
      </ConfigProvider> */}
      <Provider store={store}>
        <ConfigProvider theme={theme}>
          <BrowserRouter>
            <Router />
            {/* <ToastContainer position="top-right" autoClose={10000} /> */}
          </BrowserRouter>
        </ConfigProvider>
      </Provider>
    </>
  );
};

export default App;
